import api from "@/services/api.service";
import readXlsxFile from 'read-excel-file'
import { required } from "vuelidate/lib/validators";

export default {
  name: 'edit',
  components: {readXlsxFile},
  props: {},
  data() {
    return {
      caption: "Edit Import Contact",
      campaign_form: true,
      mapping_form: false,
      operators: [],
      showField: true,
      formField: {header_data: {}, xls_file: '',title : '',tags:[]},
      headers: [],
      head: [],
      map_headers: [],
      file: '',
      submitStatus: null,
      existing_tags: [],
      tags:[],
      removed_tags:[],
      permission_edit: false,
      superAdmin: false
    }
  },
  computed: {},
  validations: {
    formField: {
      title: {
        required
      },        
      tags: {
        required
      }
    }
  },
  async created() {
    let response = await api.post("users/user-permissions");
        const permissions = [];
        if (response.status == "success") {
          response.data[0].permission.forEach( function(element) {                
              permissions.push(element.action)
          }.bind(this));
            if(permissions.includes("edit_import_contact") == true){
              this.getTags();
              this.getImportedContactList();
              this.permission_edit = permissions.includes("edit_import_contact");
            }else if(response.data[0].role == 'super_admin'){
              this.getImportedContactList();
              this.getTags();
              this.superAdmin = true;
          }else if(permissions.includes("list_import_contact") == true || permissions.includes("add_import_contact") == true){
              this.makeToast("Permission denied","Alert","warning",6000);
              this.$router.push({name: 'Import Contact List'});
          }else{
              this.makeToast("Permission denied","Alert","warning",6000);
              this.$router.push({name: 'Admin Dashboard'});
          }
      }
  },
  mounted() {

  },
  methods: {
    makeToast(message = '', title = 'Alert', variant = 'warning', time = '3000') {
      this.toastCount++
      this.$root.$bvToast.toast(message, {
        title: title,
        variant: variant,
        autoHideDelay: time
      })
    },
    async getImportedContactList() {      
      let response = await api.post("admin/import-contact/list", {id : this.$route.params.id});
      if (!response)
        this.makeToast("Something went to wrong please try again", "Alert", "danger", 6000);
      if (response.status == "success") {
        if (response.data != "") {
          this.formField = response.data; 
          response.data.tags.forEach( function(element) {
            this.tags.push({'id':element.id,'value':element.tags});
          }.bind(this));                                        
          this.formField.tags = this.tags;   
          this.head = response.data.map_header.map_headers;          
        } else {
          this.items = [];
        }
      }
      this.isBusy = false;
    },
    async getTags() {
      let response = await api.post("tags/list");
      if (!response)
        this.makeToast("Something went to wrong please try again","Alert","danger",6000);
      if (response.status == "success") {
        response.data.forEach(
          function(e) {
            this.existing_tags.push({ key: e.tags.substring(0, 100), value: e.tags.substring(0, 100) });
          }.bind(this)
          );
      }
    },
    onTagRemoved(tag){
      this.removed_tags.push(tag.id);
    },
    async showMappedForm() {      
      this.campaign_form = false;
      this.mapping_form = true;      
      if (this.formField.xls_file) {
        this.head = [];
        this.head = this.headers.map((h) => {
          return {name: h, 'value': ''}
        });
      }
      
      let response = await api.post('admin/mapping_headers/list');
      if (!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

      if (response.status == 'success') {
        if (response.data != '') {
          for (var key in response.data.data) {
            this.map_headers.push({value: response.data.data[key].column_key, text: response.data.data[key].column})
          }
        } else {
          this.map_headers = [];
          this.makeToast(`No database headers found.`, 'Alert', 'danger')
        }
      } else
      this.makeToast(`No database headers found.`, 'Alert', 'danger')


    },
    async save() {
      if(this.head.length == 0){
        this.makeToast("Please select any header", "Alert", "danger");
        return;
      }
      if (this.head) {
        this.formField.map_headers = this.head;
        this.formField.id = this.$route.params.id;        
        this.formField.removed_tags = this.removed_tags;
        
        let response = await api.post('admin/import-contact/edit', this.formField);
        if (!response)
          this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

        if (response.status == 'success') {            
          this.makeToast(response.message, 'Success', 'success')
          this.$router.push({'name': 'Import Contact List'})
        } else {
          for (var error in response.errors)
            this.makeToast(response.errors[error], 'Alert', 'danger', 6000)
        }
      } else {
        this.makeToast(`Header not mapped ,please try again.`, 'Alert', 'danger')
        return false;
      }
    },
    onFileChanged(e) {
      let file = e.target.files[0];
      let reader = new FileReader();

      /*if (file.type !=="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        this.makeToast("File must  be xlsx", "Alert", "danger");
        return;
      }*/
      reader.onload = e => {
        let decode = e.target.result;
        readXlsxFile(decode).then(rows => {
          this.headers = rows[0];          
        },this.headers);

        this.formField.xls_file = btoa(decode);
      };
      reader.readAsBinaryString(file);
    },
  }
}

